import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const BitcoinIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_149030)">
        <path
          d="M31.5208 19.8706C29.3836 28.442 20.7012 33.6584 12.1279 31.521C3.55807 29.384 -1.65893 20.7021 0.479276 12.1312C2.61548 3.55876 11.2978 -1.65818 19.8686 0.478792C28.4415 2.61577 33.658 11.2987 31.5208 19.8706Z"
          fill="#818891"
        />
        <path
          d="M21.6573 14.4323C21.9089 12.7511 20.6287 11.8473 18.8782 11.2444L19.446 8.96696L18.0596 8.62148L17.5068 10.8389C17.1423 10.7481 16.7679 10.6624 16.396 10.5775L16.9527 8.34548L15.5671 8L14.9989 10.2766C14.6972 10.2079 14.4011 10.14 14.1136 10.0686L14.1151 10.0614L12.2031 9.58408L11.8343 11.0647C11.8343 11.0647 12.863 11.3004 12.8413 11.315C13.4028 11.4552 13.5043 11.8268 13.4873 12.1213L12.8405 14.7158C12.8792 14.7257 12.9293 14.7399 12.9846 14.762C12.9384 14.7505 12.8891 14.7379 12.8381 14.7257L11.9315 18.3602C11.8627 18.5307 11.6886 18.7866 11.2961 18.6894C11.3099 18.7096 10.2884 18.4379 10.2884 18.4379L9.6001 20.0248L11.4043 20.4745C11.7399 20.5586 12.0689 20.6466 12.3927 20.7296L11.8189 23.033L13.2038 23.3785L13.772 21.0995C14.1503 21.2022 14.5175 21.297 14.8769 21.3862L14.3106 23.6545L15.6971 24L16.2708 21.7009C18.6349 22.1482 20.4127 21.9678 21.161 19.8297C21.764 18.1082 21.131 17.1152 19.8871 16.4677C20.793 16.2588 21.4753 15.663 21.6573 14.4323ZM18.4896 18.8738C18.0612 20.5953 15.1624 19.6647 14.2226 19.4313L14.9839 16.3796C15.9237 16.6142 18.9374 17.0785 18.4896 18.8738ZM18.9185 14.4074C18.5275 15.9734 16.1148 15.1778 15.3322 14.9827L16.0224 12.2149C16.8051 12.4099 19.3256 12.774 18.9185 14.4074Z"
          fill="white"
        />
      </g>

      <defs>
        <clipPath id="clip0_2177_149030">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
